<template>
  <ResetPasswordExpired />
</template>

<script>
import ResetPasswordExpired from '../components/templates/ResetPasswordExpired'

export default {
  components: {
    ResetPasswordExpired
  }
}
</script>
